import React from 'react';
// vendor logos
import Equifax from '../images/logos/Equifax.svg';
import Guesty from '../images/logos/Guesty.svg';
import Shopify from '../images/logos/Shopify.svg';
import Thomson_Reuters from '../images/logos/Thomson_Reuters.svg';
import Twilio from '../images/logos/Twilio.svg';
import aws from '../images/logos/aws.svg';
import TransUnion from '../images/logos/TransUnion.svg';
import Hostaway from '../images/logos/Hostaway.svg';
import DataDog from '../images/logos/DataDog.svg';
import CIC from '../images/logos/CIC.svg';
import FullContact from '../images/logos/Full_Contact.svg';
// footer logos
import NIST from '../images/logos/NIST.svg';
import Aicpa from '../images/logos/AICPA.png';
import HIPPA from '../images/logos/HIPPA.svg';
import PCI from '../images/logos/PCI.svg';
import iBetaLevel2 from '../images/logos/iBeta.png';
// TCM page: build trust section logos
import Mitigate from '../images/product-assets/mitigate.svg';
import Preserve from '../images/product-assets/preserve.svg';
import Support from '../images/product-assets/support.svg';
import Stay from '../images/product-assets/stay.svg';
import Cost_Effective from '../images/product-assets/cost_effective.svg';
import Stay_Informed from '../images/product-assets/stay_informed.svg';
// integration section logos
import LinkIcon from '../images/verification_link_icon.svg';
import MobileSdkIcon from '../images/mobile_sdk_icon.svg';
import WebSdkIcon from '../images/web_sdk_icon.svg';
import theme from '../themes/theme';
import Authenticate_RGB from '../images/logos/authenticate_rgb.svg';
import AuthenticateWhiteLogo from '../images/logos/authenticate_light.svg';
import link_hover_blue from '../images/link_hover_blue.svg';
import link_hover_white from '../images/link_hover_white.svg';

import Ecommerce from '../images/authenticate-icon-ecommerce-alt-blue.svg';
import Freelance from '../images/authenticate-icon-freelance-blue.svg';
import OnlineCheckIn from '../images/authenticate-icon-online-check-in-blue.svg';
import OnlineMarketplace from '../images/authenticate-icon-online-marketplace-blue.svg';
import PeerToPeerLending from '../images/authenticate-icon-peer-to-peer-lending-blue.svg';
import AgeVerification from '../images/authenticate-icon-age-verification-light-blue.svg';
import FraudProtection from '../images/authenticate-icon-fraud-protection-light-blue.svg';
import SellerVerification from '../images/authenticate-icon-seller-verification-alt-light-blue.svg';
import WorkerVerification from '../images/authenticate-icon-worker-verification-light-blue.svg';
import ContinuousAuth from '../images/authenticate-icon-continuous-authentication-alt2-light-blue.svg';
// Navbar submenu logos
import Identity_card from '../images/product-assets/identity-card.svg';
import Search_round from '../images/product-assets/search-round.svg';
import Processing from '../images/product-assets/processing.svg';
import Fingerprint from '../images/product-assets/fingerprint-icon.svg';
import Group from '../images/product-assets/group.svg';
import Code from '../images/product-assets/code.svg';
import Blogs from '../images/product-assets/blogs.svg';
import Info_icon from '../images/product-assets/info.svg';
// compliance page assets
import Lock from '../images/product-assets/Lock.svg';

export const vendorLogosList = [
    { id: 0, name: 'Equifax', link: 'https://www.equifax.com/', logo: Equifax },
    {
        id: 6,
        name: 'Guesty',
        link: 'https://www.guesty.com/marketplace-items/authenticating-com/',
        logo: Guesty,
    },
    {
        id: 1,
        name: 'Shopify',
        link: 'https://apps.shopify.com/authenticating',
        logo: Shopify,
    },
    {
        id: 2,
        name: 'Thomson Reuters',
        link: 'https://www.thomsonreuters.com/en.html',
        logo: Thomson_Reuters,
        customSize: true,
    },
    { id: 5, name: 'Twilio', link: 'https://www.twilio.com/', logo: Twilio },
    { id: 3, name: 'AWS', link: 'https://aws.amazon.com/', logo: aws },
    {
        id: 4,
        name: 'TransUnion',
        link: 'https://www.transunion.com/',
        logo: TransUnion,
    },
    {
        id: 7,
        name: 'Hostaway',
        link: 'https://www.hostaway.com/marketplace/authenticating-com/',
        logo: Hostaway,
    },
    {
        id: 8,
        name: 'DataDog',
        link: 'https://www.datadoghq.com/',
        logo: DataDog,
    },
    { id: 9, name: 'CIC', link: 'https://www.cicreports.com/', logo: CIC },
    {
        id: 10,
        name: 'Full Contact',
        link: 'https://www.fullcontact.com/',
        logo: FullContact,
    },
];

export const footerLogos = [
    {
        id: 0,
        name: 'NIST',
        link: 'https://pages.nist.gov/800-63-3/sp800-63-3.html',
        tooltipText:
            'Authenticate strives to maintain the highest security standards, are in process of obtaining a military grade opinion letter.',
        logo: NIST,
    },
    {
        id: 1,
        name: 'AICPA',
        link: 'https://cdn.authenticating.com/public/website/Authenticating.com_Audit_Confirmation_letter_SOC_2.pdf',
        tooltipText:
            'Authenticate is voluntarily, independently certified as SOC 2 Type II compliant by an AICPA® accredited CPA. The full report is available upon request.',
        logo: Aicpa,
    },
    {
        id: 2,
        name: 'HIPPA',
        link: 'https://cdn.authenticating.com/public/website/Authenticating+Certificate+of+Compliance+-+123122.pdf',
        tooltipText:
            'Authenticate has been voluntarily independently audited for compliance with HIPAA Security rule 45 CFR parts §164.308, §164.310, §164.312. Full report can be furnished upon request.',
        logo: HIPPA,
    },

    {
        id: 3,
        name: 'PCI',
        link: 'https://cdn.authenticating.com/public/website/PCI-DSS-v4_0.pdf',
        tooltipText:
            'Authenticate has an Attestation of Compliance available upon request as well as a PCI DSS Self-Assessment Questionnaire.',
        logo: PCI,
    },
    {
        id: 4,
        name: 'iBeta_Level_2',
        link: 'https://www.idrnd.ai/ibeta-iso-30107-3/',
        tooltipText: false,
        logo: iBetaLevel2,
    },
];

// FAQ of Identity verification product page
export const idProductPageFaq = [
    {
        id: 0,
        title: 'What is Medallion™?',
        desc: 'Medallion™, is a web-based application that offers a user-friendly authentication solution to quickly prove the identity and check the background of individuals and businesses. Medallion™ streamlines the verification process with real-time feedback, automated ID type recognition, and built-in fallback manual review.',
    },
    {
        id: 1,
        title: 'How long does it take to complete the verification process?',
        desc: 'Medallion™ is designed to help users instantly verify themselves through a guided experience with minimal friction. On average it takes only a minute or two.',
    },
    {
        id: 2,
        title: 'What modes of verifications do we use?',
        desc: 'There are five ways to prove your identity with Authenticate. Knowledge Based Authentication (KBA) quizzes, photo ID authentication, SSN trace, bank account login or "out-of-band" authentication with an email and phone number known to be associated with the same identity. KBA is available only in the US. Photo ID authentication is an instant forensic forgery and fraud analysis of any government issued photo identification or passport from 250 countries, territories and issuing authorities around the world in 38 different languages.',
    },
    {
        id: 3,
        title: 'What information is needed for the verification process?',
        desc: 'Knowledge based authentication only requires name, date of birth & some, none or all of the SSN. A photo ID authentication requires only photos to be taken of the ID or passport. A bank account login requires using a username and password combination along with a second factor of authentication established by the bank or financial institution. If a workflow is configured to accept "out of band" authentication with an email and phone number known to be associated with the same identity, they would simply need to enter a unique six digit code that is sent to each identifier.',
    },
    {
        id: 4,
        title: 'What are Medallion™ Workflows?',
        desc: 'Medallion™ workflows are customizable experiences based on your verification needs and preferences. It allows multiple verification options, whitelisted countries to accept documents from, as well as criminal, education, employment and professional license checks if desired.',
    },
];

// FAQ of TCM product page
export const tcmProductPageFaq = [
    {
        id: 0,
        title: "What's the U.S. Population Coverage?",
        desc: 'TCM leverages advanced technology to scour thousands of sources every minute, providing comprehensive coverage of over 95% of the U.S. population.',
    },
    {
        id: 1,
        title: "What's the difference between TCM & Arrest Monitoring?",
        desc: (
            <>
                True Continuous Monitoring is a major step up from arrest monitoring. Arrest
                monitoring primarily focuses on notifying you when someone has been booked in jail.
                It may be helpful to know when a user is arrested so it’s on a business’s radar, but
                sometimes the process doesn’t stop there. And the keyword there is *sometimes*. An
                arrest may or may not get formally filed as a criminal case. Additionally, the time
                between an arrest and a charge being filed varies greatly. For example, we recently
                had a situation where a subject was arrested in August 2022, and the charge was not
                filed as a criminal case until February of 2023 – that’s 6 months of crickets and 6
                months of exposure for that organization! <br />
                <br /> The uncertainty of not knowing when (or if) a charge will formally be filed
                and when to run a standard county criminal search is where TCM becomes meaningful.
                While arrest monitoring serves a specific purpose, TCM takes it a step further by
                tracking criminal cases from the moment they are filed with the court until
                their disposal, providing updates as the case goes through each step of the judicial
                process. This comprehensive coverage ensures that no important updates are missed
                and means companies don’t have to worry about wondering when or if to follow up on
                an arrest alert.
            </>
        ),
    },
    {
        id: 2,
        title: 'What % of U.S. incarceration facilities are covered?',
        desc: '85%+ U.S. incarceration facilities are covered.',
    },
    {
        id: 3,
        title: 'How much does enrolling one user cost?',
        desc: 'It costs $5 per person per year.',
    },
];

// submenu item list of navbar
export const productsSubMenuItems = [
    {
        id: 0,
        title: 'Identity Verification',
        link: { route: '/products/identity' },
        desc: 'Confirm Identity instantly & securely.',
        icon: Identity_card,
    },
    {
        id: 1,
        title: 'Criminal Background',
        link: { route: '/products/criminal-background-checks' },
        desc: 'Comprehensive Criminal Record Checks.',

        icon: Fingerprint,
    },
    {
        id: 2,
        title: 'Background Verification',
        link: { route: '/products/background-check' },
        desc: 'Verify education, employment, and much more.',
        icon: Group,
    },
    {
        id: 3,
        title: 'True Continuous Monitoring™',
        link: { route: '/products/tcm' },
        desc: 'Real-Time arrest monitoring.',
        icon: Search_round,
    },
    {
        id: 4,
        title: 'ReAuthenticate™',
        link: { route: '/products/reauthenticate' },
        desc: 'Re-KYC made simpler!',
        icon: Processing,
    },
];

// resources submenu items
export const resourcesSubMenuItems = [
    {
        id: 1,
        title: 'Security & Compliance',
        link: {
            route: '/resources/security-and-compliance',
        },
        desc: 'Trust and Integrity',
        icon: Lock,
    },
    {
        id: 2,
        title: 'Documentation',
        link: {
            route: 'https://docs.authenticate.com/',
            target: '_blank',
            rel: 'noreferrer',
        },
        desc: 'Developer Hub',
        icon: Code,
    },
    {
        id: 3,
        title: 'Blog',
        link: {
            route: '/resources/blog',
        },
        desc: 'Dive Deeper',
        icon: Blogs,
    },
    {
        id: 4,
        title: 'Knowledge Base',
        link: {
            route: 'https://info.authenticate.com/',
            target: '_blank',
            rel: 'noreferrer',
        },
        desc: 'Information Center',
        icon: Info_icon,
    },
];

// TCM Page: Build trust section card object

export const tcmInfoCards = [
    {
        id: 0,
        icon: Mitigate,
        alt: 'Mitigate',
        title: (
            <>
                <span>Mitigate</span> negligent retention liability
            </>
        ),
        description:
            'True Continuous Monitoring blends modern risk management with cost-effective technology, enabling proactive risk mitigation before problems arise.',
    },
    {
        id: 1,
        icon: Preserve,
        alt: 'Preserve',
        title: (
            <>
                <span>Preserve</span> brand reputation
            </>
        ),
        description:
            'TCM helps to identify people who have recently been arrested, booked, warranted or incarcerated for a crime, which can help to protect you from a possible security concern.',
    },
    {
        id: 2,
        icon: Support,
        alt: 'Support',
        title: (
            <>
                <span>Support</span> trust and safety
            </>
        ),
        description:
            'TCM can help to identify potential problems before they arise whenever someone is formally implicated in a serious matter. This adds protection and confidence in your security measures.',
    },
    {
        id: 3,
        icon: Stay,
        alt: 'Stay',
        title: (
            <>
                <span>Stay</span> ahead of risk
            </>
        ),
        description:
            'Set it and forget it. TCM reduces liability for you and your stakeholders. This product is purpose built to stop loss, deter theft, prevent fraud and mitigate risks of every kind.',
    },

    {
        id: 4,
        icon: Cost_Effective,
        alt: 'Cost Effective',
        title: (
            <>
                <span>Cost Effective</span> for business
            </>
        ),
        description:
            'Continuous monitoring reports real-time criminal activity without extra re-screen costs. You only pay for individuals on your roster. Monitoring is flexible enough to segment high-priority individuals.',
    },
    {
        id: 5,
        icon: Stay_Informed,
        alt: 'Stay Informed',
        title: (
            <>
                <span>Stay Informed</span> every step of the process
            </>
        ),
        description:
            'TCM’s comprehensive coverage ensures that no important updates are missed and you don’t have to worry about when or if it’s necessary to recheck people who may be on the move throughout the US.',
    },
];

export const integrationCards = [
    {
        id: 0,
        title: 'Verify by Link',
        logoSrc: LinkIcon,
        altText: 'Link Icon',
        description:
            'Generate a tokenized link to a custom branded workflow. Includes enhanced features like auto-image capture, expert manual review, facial recognition and passive liveness detection.',
        link: 'https://docs.authenticate.com/reference/post_user-jwt-1',
    },
    {
        id: 1,
        title: 'Web SDK',
        logoSrc: WebSdkIcon,
        altText: 'Web SDK Icon',
        description:
            'Embed a React application within the four corners of your application to give users a browser-based, authentication experience without needing to code.',
        link: 'https://docs.authenticate.com/docs/medalliontm',
    },
    {
        id: 2,
        title: 'Mobile SDKs',
        logoSrc: MobileSdkIcon,
        altText: 'Mobile SDK Icon',
        description:
            'Create mobile native applications for iOS or Android with our mobile SDKs that include active liveness detection for facial recognition and liveness detection.',
        link: 'https://docs.authenticate.com/docs/android-developer-app',
    },
];

export const defaultNavProps = {
    navBgColor: theme.colors.navbarBgPrimary,
    logo: Authenticate_RGB,
    linkColor: theme.colors.navbarTextPrimary,
    linkHoverIcon: link_hover_blue,
};

export const scrollNavProps = {
    navBgColor: theme.colors.transparent,
    logo: AuthenticateWhiteLogo,
    linkColor: theme.colors.white,
    linkHoverIcon: link_hover_white,
};

export const reauthentcateBenefits = [
    {
        id: 1,
        title: 'Enhanced User Experience',
        description:
            "By minimizing the steps required for repeat verification's, users enjoy a more seamless interaction, reducing dropout rates.",
    },
    {
        id: 2,
        title: 'Improved Efficiency',
        description:
            "By minimizing the steps required for repeat verification's, users enjoy a more seamless interaction with services, reducing dropout rates during the verification process.",
    },
    {
        id: 3,
        title: 'Cost-Effective',
        description:
            'Reducing the need for multiple, comprehensive KYC checks for repeat users can lower operational costs.',
    },
    {
        id: 4,
        title: 'Compliance and Security',
        description:
            'Maintains high standards of security and regulatory compliance by ensuring that initial verifications are thorough and by using advanced technology for subsequent checks.',
    },
];

export const vendorLogosListReauth = [
    { id: 1, name: 'AWS', link: 'https://aws.amazon.com/', logo: aws },

    { id: 2, name: 'Equifax', link: 'https://www.equifax.com/', logo: Equifax },
    {
        id: 3,
        name: 'Guesty',
        link: 'https://www.guesty.com/marketplace-items/authenticating-com/',
        logo: Guesty,
    },
    {
        id: 4,
        name: 'Shopify',
        link: 'https://apps.shopify.com/authenticating',
        logo: Shopify,
    },
    {
        id: 5,
        name: 'Thomson Reuters',
        link: 'https://www.thomsonreuters.com/en.html',
        logo: Thomson_Reuters,
    },
    { id: 6, name: 'Twilio', link: 'https://www.twilio.com/', logo: Twilio },

    { id: 7, name: 'CIC', link: 'https://www.cicreports.com/', logo: CIC },
    {
        id: 8,
        name: 'DataDog',
        link: 'https://www.datadoghq.com/',
        logo: DataDog,
    },
    {
        id: 9,
        name: 'Full Contact',
        link: 'https://www.fullcontact.com/',
        logo: FullContact,
    },
    {
        id: 10,
        name: 'Hostaway',
        link: 'https://www.hostaway.com/marketplace/authenticating-com/',
        logo: Hostaway,
    },
    {
        id: 11,
        name: 'TransUnion',
        link: 'https://www.transunion.com/',
        logo: TransUnion,
    },
];

export const reauthenticateFaq = [
    {
        id: 0,
        title: 'What types of photo documents does ReAuthenticate™ accept?',
        desc: 'ReAuthenticate™ accepts selfies for authentication. Alternatively, if the selfie doesn’t match, it accepts any Government-Issued Photo IDs.',
    },
    {
        id: 1,
        title: 'What is the pricing for ReAuthenticate™?',
        desc: 'ReAuthenticate™ is a free service.',
    },
    {
        id: 2,
        title: 'Can you customize the ReAuthenticate™ experience to match your brand and workflow?',
        desc: 'Yes, ReAuthenticate™ can match your brand and workflow.',
    },
    {
        id: 3,
        title: 'Can ReAuthenticate™ offer seamless integration with your existing user management system or other relevant platforms?',
        desc: 'ReAuthenticate™ and Medallion™ have the same integration methods available via APIs or our integrations.',
    },
];

export const reAuthenticateUseCases = {
    eCommerce: {
        id: 1,
        heading: 'E-commerce',
        content: [
            {
                id: 1,
                title: 'Age Verification',
                iconSrc: AgeVerification,
                description:
                    'Ensure legal compliance by accurately verifying customer age for age-restricted products with ease.',
            },
            {
                id: 2,
                title: 'Fraud Prevention',
                iconSrc: FraudProtection,
                description:
                    'Verifying the identity of users to prevent fraudulent transactions, especially in high-value purchases or when red flags are detected.',
            },
        ],
        headingIconSrc: Ecommerce,
    },
    onlineMarketPlace: {
        id: 2,
        heading: 'Online Marketplace',
        content: [
            {
                id: 1,
                title: 'Seller Verification',
                iconSrc: SellerVerification,
                description:
                    'To prevent fraudulent listings and ensure trustworthiness of sellers by verifying their identity. E-commerce platforms can ensure that sellers are verified, which in turn builds buyer trust.',
            },
            {
                id: 2,
                title: 'Buyer Protection',
                iconSrc: WorkerVerification,
                description:
                    'ReAuthenticate enhances buyer protection by quickly verifying identities, minimizing fraud, and ensuring secure, trustworthy transactions.',
            },
        ],
        headingIconSrc: OnlineMarketplace,
    },
    peerToPeerLending: {
        id: 3,
        heading: 'Peer-to-Peer Lending Platforms',
        content:
            'ReAuthenticate ensures P2P lending platforms meet KYC and AML regulations efficiently, preventing legal penalties and bolstering their reputation for reliability and compliance.',
        headingIconSrc: PeerToPeerLending,
    },
    onlineCheckIn: {
        id: 4,
        heading: 'Online Check-ins',
        content:
            'Enhance security and elevate the customer journey with our identity verification solution for online check-ins. Ensure your services are accessed by the rightful guests every time, paving the way for a personalized, seamless experience from airlines to hotel stays.',
        headingIconSrc: OnlineCheckIn,
    },
    freelancePlatforms: {
        id: 5,
        heading: 'Gig Economy and Freelance Platforms',
        content: [
            {
                id: 1,
                title: 'Worker Verification',
                iconSrc: WorkerVerification,
                description:
                    'Ensuring that the freelancers or gig workers are who they claim to be, which is crucial for trust and safety on these platforms.',
            },
            {
                id: 2,
                title: 'Continuous Authentication',
                iconSrc: ContinuousAuth,
                description:
                    'For ongoing work engagements, periodically verifying the identity of workers to prevent account takeover or fraud.',
            },
        ],
        headingIconSrc: Freelance,
    },
};

export const pricingData = {
    free: [
        {
            id: 1,
            title: 'Email Verification',
            toolTipNote:
                'Verify an email address with a time-sensitive, six digit passcode that is sent to the user.',
            link: 'https://docs.authenticate.com/reference/post_user-verifyemail',
        },
        {
            id: 2,
            title: 'Phone Number Verification',
            toolTipNote:
                'Verify a mobile phone number worldwide with a time-sensitive, six digit passcode that is sent to the user.',
            link: 'https://docs.authenticate.com/reference/post_user-verifyphone',
        },
        {
            id: 3,
            title: 'Facial Recognition & Liveness Detection *',
            toolTipNote:
                'Verify the likeness of a face in two images by comparing photos & receiving an instant correlation score. The comparison photo will also be measured for liveness using iBeta Level 2 anti-spoofing technology.',
            link: 'https://docs.authenticate.com/reference/post_user-comparephotos',
        },
        {
            id: 4,
            title: 'Authoritative Database Search *',
            toolTipNote:
                'Verify the user’s data with Authoritative databases in the United States.',
            link: 'https://docs.authenticate.com/reference/post_identity-document-scan-data',
        },
        {
            id: 5,
            title: 'US Criminal Database Search *',
            toolTipNote:
                'Generate a TRUE or FALSE response if any records may be available for the user in sex offender registries or criminal records databases from all 50 US states. This search may also include digitized records from Department of Corrections, Administrative Office of the Courts & county courts. Coverage varies by state.',
            link: 'https://docs.authenticate.com/reference/post_user-generatecriminalreport',
        },
        {
            id: 6,
            title: 'Global Watchlist Search *',
            toolTipNote:
                'Generate a TRUE or FALSE verification response if there appear to be any global watch list records matching the proven identity by at least 65%. This search includes 60+ sanctions & watch lists, including OFAC (SDNs & other lists), EU Consolidated List, HM Treasury Sanctions, UN Consolidated List, FBI Most Wanted & more.',
            link: 'https://docs.authenticate.com/reference/post_identity-request-watchlist-global',
        },
        {
            id: 7,
            title: 'Score Inputs',
            toolTipNote:
                'Score Inputs tell you whether or not the input data on a specific user matches the data we have in our proprietary identity graph—and offers a risk score based on the match (or lack thereof).',
            link: 'https://docs.authenticate.com/reference/post_identity-risk-match',
        },
    ],
    $1: [
        {
            id: 1,
            title: 'Government ID Verification',
            toolTipNote:
                "Verify a two sided ID with a photo of the front of the document which is read with OCR & a photo of the back of the document where the barcode is decoded & matched with the data from the front with all the information on the document returned along with our degree of confidence that it's authentic.",
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-document-scan',
        },
        {
            id: 2,
            title: 'Knowledge Based Authentication',
            toolTipNote:
                "Verify & authenticate identity with a personal knowledge quiz generated from the user's name & date of birth & some, none or all of the SSN.",
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-kba-verification',
        },
        {
            id: 3,
            title: 'International Authoritative Database Search *',
            toolTipNote:
                'Verify the user’s data with Authoritative databases in 40 counties worldwide.',
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-verify-international',
        },
        {
            id: 4,
            title: 'SSN Verification',
            toolTipNote: 'Verify a person’s SSN.',
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_user-verify-ssn',
        },
        {
            id: 5,
            title: 'FEIN, Tax ID & DUNS® Verification',
            toolTipNote:
                'Verify an entity’s name, FEIN, Tax ID & DUNS Number and if the user is a business contact or not.',
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-business-verification',
        },
        {
            id: 6,
            title: 'Global Watchlist Report',
            toolTipNote:
                'Verify Global Watch List data which covers 60+ sanctions & watch lists, including OFAC (SDNs & other lists), EU Consolidated List, HM Treasury Sanctions, UN Consolidated List, FBI Most Wanted & more matching the proven identity by at least 65% are provided.',
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-request-watchlist-global-report',
        },
        {
            id: 7,
            title: 'Verify Inputs',
            toolTipNote:
                'Verify Inputs provides you with actual input data insights into how confident we are about the given person’s identity, inputs, and risk level. Verify Inputs are highly specific and provide high-value information.',
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-risk-inputs',
        },
        {
            id: 8,
            title: 'Financial Account Ownership Verification',
            toolTipNote:
                "Securely verify users' identity through Financial account login, leveraging trusted financial credentials, powered by Mastercard.",
            price: '$1',
            link: 'https://docs.authenticate.com/reference/post_identity-bank-connect-url',
        },
    ],
    $2: [
        {
            id: 1,
            title: 'Enhanced Government ID Verification',
            toolTipNote:
                'Authenticate any government issued ID with 50 forensic tests to return an instant authentication result & a data payload of all the information on the ID. Covers over 6,000 government issued IDs from more than 200 countries & 38 languages. Includes automatic fallback, expert manual review.',
            price: '$2',
            link: 'https://docs.authenticate.com/reference/post_identity-document-scan-enhanced',
        },
    ],
    $5: [
        {
            id: 2,
            title: 'Current or Past US Employment Verification',
            toolTipNote:
                'Verify Company Name, Town, State & Country, Job Title, Date Employed From & To, Supervisor Name, if they are currently employed & what their contract type is. Pass through fees not included.',
            price: '$5',
            link: 'https://docs.authenticate.com/reference/post_employment-v2-verify',
        },
        {
            id: 3,
            title: 'US College & University Verification',
            toolTipNote:
                "Verify School Name & Type, Campus Name, School Town & Country, Start Date & End Date, Degree Title, if they are currently attending and/or if they've completed their degree successfully. Pass through fees not included.",
            price: '$5',
            link: 'https://docs.authenticate.com/reference/post_education-v2-verify',
        },
        {
            id: 4,
            title: 'US Professional License Verification',
            toolTipNote:
                'Verify License Title, Organization & Number, State & End Date, State & Country. If unavailable by database the average turnaround time is 48 hours to get a response from the source.',
            price: '$5',
            link: 'https://docs.authenticate.com/reference/post_identity-professional-license',
        },
        {
            id: 5,
            title: 'DMV & MVR Verification',
            toolTipNote:
                'Verify Motor Vehicle Records from DMVs in all 50 states. MVRs include license details such as state issued, status, expiration, suspensions, revocations, violations & sanctions. Additional DMV fees vary by state.',
            price: '$5',
            link: 'https://docs.authenticate.com/reference/post_identity-mvr',
        },
        {
            id: 6,
            title: 'Full US Business Verification ',
            toolTipNote:
                'Verify the Date of Incorporation, Address, Business Name(s), Status & Corporation Type.',
            price: '$5',
            link: 'https://docs.authenticate.com/reference/post_identity-business-verification-comprehensive',
        },
        {
            id: 7,
            title: '7 Year Criminal Activity Verification',
            toolTipNote:
                'Verify any commercially available criminal activity data that can be found nationwide for the last seven years. No pass through fees & an instant turnaround.',
            price: '$5',
            link: 'https://docs.authenticate.com/reference/post_identity-request-criminal-report-seven',
        },
        {
            id: 1,
            title: 'True Continuous Monitoring™ *',
            toolTipNote:
                'Provides alerts in near real-time about new criminal activity that could indicate threats to your business. The fee is for a one-year enrollment, which renews annually on the enrollment anniversary if the user is not removed from the watch list first.',
            price: '$5',
            link: 'https://authenticate.com/products/tcm',
        },
    ],
    '$5+': [
        {
            id: 1,
            title: 'County Criminal & Civil Record Verification **',
            toolTipNote: 'Verify any county-level criminal and/or civil records.',
            price: '$5+',
            link: 'https://docs.authenticate.com/reference/post_user-verify-criminal-county',
        },
        {
            id: 2,
            title: 'Federal Criminal & Civil Record Verification **',
            toolTipNote:
                'Verify any federal criminal and/or federal civil records. Our researchers will seek all publicly available records by default.',
            price: '$5+',
            link: 'https://docs.authenticate.com/reference/post_user-verify-criminal-federal',
        },
        {
            id: 3,
            title: 'Manual Source Level Verification',
            toolTipNote:
                'If $5 database checks are inconclusive, manual source-level verification is available for $15 plus pass through fees when applicable.',
            price: '$15',
            link: 'https://docs.authenticate.com/reference/post_education-v2-verify',
        },
    ],
};

export const priceKeyToPositionMap = {
    free: 0,
    $1: 1,
    $2: 2,
    $5: 3,
    '$5+': 4,
};
